/**
 * Constants for affiliate links feature
 */

export const AFFILIATE_LINK_STATUS = {
    ACTIVE: 'active',
    PENDING_SETUP: 'pending-setup',
} as const;

/**
 * Table empty state messages
 */
export const EMPTY_STATE = {
    NO_LINKS: {
        HEADER: 'No Affiliate Links',
        SUBHEADER: 'Affiliate products purchased from other Creators will show up here',
    },
} as const;
